import React from "react";

export default function Footer()
{
  return (
    <footer className="footer bg_cover">
      <div className="bg_f bg_cover">

      </div>
      <div className="sc-wrap">
        <div className="left">
          <div className="logo_footer">
            <a href="">
              <div className="img_ bg_contain">

              </div>
              <span>Rocket Racocon</span>
            </a>
          </div>
          <div className="block_10  "></div>
          <div className="block_10  "></div>
          <div className='btn_w'>
            <button className="reset_btn  btn_dark btn_dark_lg " >Whitepaper</button>
          </div>
          <div className="block_10  "></div>
          <ul className="list">
            <li><a href="">Telegram</a></li>
            <li><a href="">Channel</a></li>
            <li><a href="">Twitter</a></li>
            <li><a href="">Docs</a></li>
            <li><a href="">Reddit</a></li>
          </ul>
        </div>
        <div className="right">
          <h3>
            Check us out</h3>
          <div className="block_10  "></div>
          <div className="list_icon list_icon_2">
            <a href="">
              <div className="ic__ ic__4 bg_contain">

              </div>
            </a>
            <a href="">
              <div className="ic__ ic__5 bg_contain">

              </div>
            </a>
            <a href="">
              <div className="ic__ ic__6 bg_contain">

              </div>
            </a>
            <a href="">
              <div className="ic__ ic__7 bg_contain">

              </div>
            </a>
            <a href="">
              <div className="ic__ ic__8 bg_contain">

              </div>
            </a>
          </div>
        </div>
      </div>

      <div className="copy_">
        <p>
          © 2023 by clics. Proudly created with Wix.com
        </p>
      </div>
    </footer>
  );
}
